

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 21 21","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, rest), ["\n    ", h('g', {"id":"svg-recording-pause-circle-WVa6d7V","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, ["\n        ", h('g', {"id":"svg-recording-pause-circle-25zSPpn","transform":"translate(-31.000000, -1051.000000)","fill":"currentColor"}, ["\n            ", h('path', {"d":"M41.5,1051 C47.2989899,1051 52,1055.70101 52,1061.5 C52,1067.29899 47.2989899,1072 41.5,1072 C35.7010101,1072 31,1067.29899 31,1061.5 C31,1055.70101 35.7010101,1051 41.5,1051 Z M40,1056 L37,1056 L37,1067 L40,1067 L40,1056 Z M46,1056 L43,1056 L43,1067 L46,1067 L46,1056 Z","id":"svg-recording-pause-circle-jTGVLxo"}, []), "\n        "]), "\n    "]), "\n"]);
};

        